<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="headerabbrs01" class="chapter" epub:type="frontmatter" id="abbrs">
<header id="headerabbrs01">
<h1 class="ctfm"><span aria-label="vii" class="page" epub:type="pagebreak" id="pvii" role="doc-pagebreak"></span><a class="xref" href="#/chibentley0006#toc">Abbreviations</a></h1>
</header>
<div class="glossary">
<p class="glof"><span class="page" data-locator="pvii"></span><abbr>HJA</abbr> – Hogan Jazz Archive, Tulane University, New Orleans</p>
<p class="glo"><abbr>HNOC</abbr> – Williams Research Center, Historic New Orleans Collection, New Orleans</p>
<p class="glo"><abbr>LARC</abbr> – Louisiana Research Collection, Tulane University, New Orleans</p>
<p class="glo"><abbr>LSM</abbr> – Louisiana Historical Center, Louisiana State Museum, New Orleans</p>
<p class="glo"><abbr>NONA</abbr> – New Orleans Notarial Archives</p>
<p class="glo"><abbr>NOPL</abbr> – New Orleans Public Library</p>
<p class="glo"><abbr>SCLSU</abbr> – Special Collections, Louisiana State University, Baton Rouge, Louisiana</p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-bentley-0007.vue?0b938a9e